// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/1912
import type { PAPEventGeneric } from "../base/event";
import type { PreviewType } from "../enums/preview_type";
import type { FileType } from "../enums/file_type";
import type { SharedObjType } from "../enums/shared_obj_type";
import type { DropboxAiVariant } from "../enums/dropbox_ai_variant";
import type { Prompt_1 } from "../enums/prompt_1";
import type { Prompt_2 } from "../enums/prompt_2";
import type { Prompt_3 } from "../enums/prompt_3";
import type { DashExperience } from "../enums/dash_experience";

// Event_name: 'shown.dropbox_ai'
// Description: Summarize & Ask feature (formerly FileGPT or Dropbox AI) shown. As of 2025-03-17, this can be shown on full-page Previews and Browse.
// Owner: previews-platform
export type Shown_DropboxAi = PAPEventGeneric<
  'dropbox_ai',
  'shown',
  'dropbox_ai',
  {
    // The type of shared preview screen that was shown for this shared content
    previewType?: PreviewType;
    // a file type of a file
    fileType?: FileType;
    // The module the user will select from the Action Screen in order to perform the action. i.e. quick_actions_empty_state, quick_actions_header
    // **NOTE: you must update the allowlist if you're using this for a new value: https://dropbox.atlassian.net/wiki/spaces/PAP/pages/1093468269/Action+Element+Sanitization
    actionElement?: string;
    // determines whether or not this is being viewed on the shared links page
    isSharedLinkPage?: boolean;
    // whether or not the user is logged in
    isLoggedIn?: boolean;
    // is this being rendered on browse
    isBrowsePage?: boolean;
    // Browser width in pixels
    browserWidth?: number;
    // Browser height in pixels
    browserHeight?: number;
    // This tracks the file_id of a specific file/folder in Dropbox, which is provided by the Filesystem APIs. It is used for logs when a specific user interaction needs to be associated with a particular file.
    fileId?: string;
    // Event is associated with a Team
    isTeam?: boolean;
    // The type of shared object.
    sharedObjType?: SharedObjType;
    // true if the recipient is receiving a share from a sender of the same team.
    isInBoundSharing?: boolean;
    // what version of dash chat sidebar is showing
    dropboxAiVariant?: DropboxAiVariant;
    // fresh id that gets generated for every new session or instance of the chat window
    chatSessionId?: string;
    // first prompt shown, matches ai_landing_page_suggestion event property values, all dynamic prompts are logged to a single dynamic value
    prompt_1?: Prompt_1;
    // second prompt shown, matches ai_landing_page_suggestion event property values, all dynamic prompts are logged to a single dynamic value
    prompt_2?: Prompt_2;
    // third prompt shown, matches ai_landing_page_suggestion event property values, all dynamic prompts are logged to a single dynamic value
    prompt_3?: Prompt_3;
    // signifies if the folder is a root folder
    isRootFolder?: boolean;
    // The property used to distinguish fss dash and dash standalone features
    dashExperience?: DashExperience;
  }
>;

export function PAP_Shown_DropboxAi(properties?: Shown_DropboxAi['properties']): Shown_DropboxAi {
  return <Shown_DropboxAi>{
    class: 'dropbox_ai',
    action: 'shown',
    object: 'dropbox_ai',
    properties,
  };
}
